import { props } from '@syncfusion/ej2-vue-documenteditor/src/document-editor/documenteditor.component';

const AuthLayout = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */ '@/modules/auth/components/AuthLayout.vue');
const Login = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */ '@/modules/auth/pages/Login.vue');
const Register = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */ '@/modules/auth/pages/Register.vue');
const ForgotPassword = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */ '@/modules/auth/pages/ForgotPassword.vue');
const ResetPassword = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/pages/ResetPassword.vue');
const SetPassword = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/pages/SetPassword.vue');
const VerifySMS = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/pages/VerifySMS.vue');
const VerifyEmail = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/pages/VerifyEmail.vue');
const AuthGoogle = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/pages/AuthGoogle.vue');
const ChangePassword = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/pages/ChangePassword.vue');
const InvalidLink = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/pages/InvalidLink.vue');
const RegisterPersonal = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/pages/RegisterPersonal.vue');
const RegisterProfessional = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/pages/RegisterProfessional.vue');
const AuthRoeId = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/pages/AuthRoeId.vue');
const AuthSts = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/pages/AuthSts.vue');
export default [
    {
        path: '/auth',
        name: 'Auth',
        component: AuthLayout,
        meta: { unauth: true },
        children: [
            {
                name: 'signin',
                path: '/auth/signin',
                component: Login,
                meta: { unauth: true }
            },
            {
                name: 'signup',
                path: '/auth/signup',
                component: Register,
                meta: {
                    unauth: true,
                    notRenderInApp: true,
                }
            },
            {
                name: 'signup-personal',
                path: '/auth/signup/personal',
                component: RegisterPersonal,
                meta: {
                    unauth: true,
                    notRenderInApp: true,
                },
            },
            {
                name: 'signup-professional',
                path: '/auth/signup/professional',
                component: RegisterProfessional,
                meta: {
                    unauth: true,
                    notRenderInApp: true,
                },
            },
            {
                name: 'forgotPassword',
                path: '/auth/forgot-password',
                component: ForgotPassword,
                meta: { unauth: true }
            },
            {
                name: 'resetPassword',
                path: '/auth/reset-password',
                component: ResetPassword,
                meta: { requiresConfirmationKey: true }
            },
            {
                name: 'setPassword',
                path: '/auth/set-password',
                component: SetPassword,
                meta: { requiresConfirmationKey: true }
            },
            {
                name: 'changePassword',
                path: '/auth/change-password',
                component: ChangePassword,
                props: true,
            },
            {
                name: 'stsLogin',
                path: '/auth/sts/code/:clientId',
                component: AuthSts,
            }
        ]
    },
    {
        name: 'authGoogle',
        path: '/auth/google',
        component: AuthGoogle
    },
    {
        name: 'authRoeId',
        path: '/auth/roeid',
        component: AuthRoeId
    },
    {
        name: 'verifyEmail',
        path: '/auth/confirm-email',
        component: VerifyEmail,
        meta: { requiresEmailVerification: true }
    },
    {
        name: 'verifySMS',
        path: '/auth/verify-sms',
        component: VerifySMS,
        meta: {
            requiresPhoneVerification: true,
            requiresTokenVerification: true,
        },
    },
    {
        name: 'invalidLink',
        path: '/auth/invalid-link',
        component: InvalidLink
    },
];
